module.exports = __webpack_public_path__ + "static/media/boom.6d8d9a10.gif";